<template>
  <div class="avue-logo">

    <img v-if="!isCollapse" alt="" class="img1" src="../../assets/images/logo.png">
    <div v-else class="img2"/>
    <transition-group name="fade">
      <!--  -->
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "loGo",
  data() {
    return {};
  },
  created() {},
  computed: {
    ...mapGetters(["website",'isCollapse'])

  },
  methods: {}
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-active {
  transition: opacity 2.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.avue-logo {
  line-height: 65px;
  text-align: center;
  padding-right: 5px;
  position: fixed;
  top: 0;
  left: 0;
  width: 240px;
  height: 64px;
  //background-image: linear-gradient(38deg, #FFA56C 70%, #DF2E2D 100%)!important;
  //background-color: #20222a;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;
  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 20px;
  }
  &_subtitle {
    display: block;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
  .img1 {
    text-align: center;
    margin-top: 10px;
    width: 155px;
    height: 40px;
    //background-image: url("../../assets/images/logo.png") !important;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
  }
  .img2 {
    margin: 10px auto;
    width: 45px;
    height: 40px;
    background-image: url("../../assets/images/minilogo.png") !important;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
  }
}
</style>
